import {CloseOutlined} from "@ant-design/icons";
import {Button, Col, Input, List, Modal, Row, Table} from "antd";
import {useEffect, useState} from "react";
import i18next from "i18next";
import * as UserBackend from "../../services/UserBackend";
import * as Setting from "../../conf/Setting";
import * as IconFont from "../common/IconFont";
import "../../assets/styles/user/UserTransfer.less";

export const RoleUserTransfer = (props) => {
  const {visible, dismiss, confirmLoading, onConfirmSelect, owner, defaultUsers} = props;
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [transferedNodes, setTransferedNodes] = useState([]);
  const [userList, setUserList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [pagination, setPagination] = useState({current: 1,
    pageSize: 10});

  useEffect(() => {
  });

  useEffect(() => {
    setCheckedKeys([]);
    setTransferedNodes([]);
    if (visible) {
      setUserList([]);
      if (defaultUsers) {
        const keys = defaultUsers.map(item => item.id);
        setCheckedKeys(keys);
        setTransferedNodes(defaultUsers);
      }
      fetchTreeData({pagination: pagination, searchText: searchText});
    }
  }, [visible]);

  const fetchTreeData = (params = {}) => {
    setLoading(true);
    UserBackend.getOrganizationUsers(Setting.Admin, owner, 0, params.pagination.current,
      params.pagination.pageSize, "", params.searchText)
      .then((res) => {
        setLoading(false);
        if (res.status === "ok") {
          if (res.data === null) {
            setUserList([]);
          } else {
            setUserList(res.data);

            setPagination({
              ...params.pagination,
              total: res.data2,
            });
          }
        }
      }).catch(error => {
        setLoading(false);
        Setting.showResponseMessage(error);
      });
  };

  const handleConfirm = () => {
    if (transferedNodes.length === 0) {
      Setting.showMessage("error", i18next.t("role:Please select members"));
      return;
    }
    onConfirmSelect(transferedNodes);
  };

  const onClickRemove = (data) => {
    const list = transferedNodes.filter(item => {
      return item.id !== data.id;
    });
    setTransferedNodes(list);
    setCheckedKeys(list.map(item => item.id));
  };

  const onSearchKey = (value) => {
    fetchTreeData({pagination: pagination, searchText: value});
  };

  const columns = [
    {
      title: i18next.t("user:Name"),
      dataIndex: "name",
      key: "name",
      width: "120px",
      ellipsis: true,
    },
    {
      title: i18next.t("user:Display name"),
      dataIndex: "displayName",
      key: "displayName",
      width: "120px",
      ellipsis: true,
    },
  ];

  const rowSelection = {
    selectedRowKeys: checkedKeys,
    onSelect: (record, selected, selectedRows, nativeEvent) => {
      if (!selected) {
        const list = transferedNodes.filter(item => {
          return item.id !== record.id;
        });
        setTransferedNodes(list);
        const checkList = checkedKeys.filter(item => item !== record.id);
        setCheckedKeys(checkList);
      } else {
        const checkList = checkedKeys.map(item => item);
        const transferedList = transferedNodes.map(item => item);
        checkList.push(record.id);
        transferedList.push(record);
        setCheckedKeys(checkList);
        setTransferedNodes(transferedList);
      }
    },
    onSelectAll: (selected, selectedRows, changeRows) => {

    },
  };

  const paginationProps = {
    total: pagination.total,
    showQuickJumper: true,
    showSizeChanger: false,
    showTotal: () => i18next.t("general:{total} in total").replace("{total}", pagination.total),
  };

  const handleTableChange = (pagination, filter, sorter) => {
    fetchTreeData({
      pagination,
      searchText: searchText,
    });
  };

  return <Row>
    <Modal
      className="modal-import-user"
      maskClosable={false}
      destroyOnClose={true}
      title={i18next.t("role:Select users")}
      visible={visible}
      okText={i18next.t("general:Confirm")}
      cancelText={i18next.t("general:Cancel")}
      confirmLoading={confirmLoading}
      onCancel={() => {dismiss();}}
      onOk={handleConfirm}
      width={804}
    >
      <Row style={{marginTop: "20px", marginBottom: "20px"}} justify="center">
        <div style={{width: "345px"}}>
          {i18next.t("role:Please select users")}
          <div style={{width: "100%", height: "600px", overflow: "auto", borderStyle: "solid", borderColor: "#DDDDDD", borderWidth: "1px"}}>
            <Table
              className="user-table"
              columns={columns}
              dataSource={userList}
              rowKey="id"
              size="small"
              pagination={paginationProps}
              rowSelection={rowSelection}
              tableLayout="fixed"
              title={() => (
                <>
                  <Row style={{marginBottom: "8px"}}>
                    <Col>
                      <Input.Search
                        style={{
                          marginTop: 20,
                          marginBottom: 8,
                          marginLeft: 20,
                          width: "100%",
                        }}
                        allowClear={true}
                        placeholder={i18next.t("role:Please input username or name")}
                        onChange={(e) => {setSearchText(e.target.value);}}
                        onSearch={(value) => {
                          onSearchKey(value);
                        }}
                      />
                    </Col>
                  </Row>
                </>
              )}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
        <Row align="middle" justify="center" style={{width: "30px"}}>
          <IconFont.ArrowFillingRightIcon style={{color: "#BBBBBB", fontSize: 24}} />
        </Row>
        <div style={{width: "345px"}}>
          {i18next.t("role:Selected users")}
          <div style={{width: "100%", height: "600px", overflowY: "auto", borderStyle: "solid", borderColor: "#DDDDDD", borderWidth: "1px"}}>
            <List
              className="user-tansfer-list"
              size="small"
              split={false}
              dataSource={transferedNodes}
              renderItem={item => <List.Item style={{width: "100%"}}>
                <IconFont.MemberIcon style={{marginLeft: "5px", marginRight: "5px", color: "#333333", fontSize: 16}} />
                <span style={{width: "calc(100% - 24px - 32px)", display: "inline-block", overflow: "hidden",
                  whiteSpace: "nowrap", textOverflow: "ellipsis"}}>{item.displayName}&nbsp;({item.name})</span>
                <Button icon={<CloseOutlined style={{font: "12px", color: "#999999"}} />} type="text" onClick={(e) => onClickRemove(item)}></Button>
              </List.Item>}
            />
          </div>
        </div>
      </Row>
    </Modal>
  </Row>;
};

export default RoleUserTransfer;
